var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSidebarFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_845_16854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.7417C17.6391 17.7417 18.5625 16.8183 18.5625 15.6792C18.5625 14.5401 17.6391 13.6167 16.5 13.6167C15.3609 13.6167 14.4375 14.5401 14.4375 15.6792C14.4375 16.8183 15.3609 17.7417 16.5 17.7417Z",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 19.8042C14.0654 18.6183 15.1766 17.7417 16.5 17.7417C17.8234 17.7417 18.9346 18.6183 19.25 19.8042",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 7.4292V5.3667C2.75 5.18436 2.82243 5.00949 2.95136 4.88056C3.0803 4.75163 3.25516 4.6792 3.4375 4.6792H7.96555C8.14764 4.67928 8.32226 4.75161 8.45109 4.88029L11 7.4292",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3606 18.4292H3.38422C3.21615 18.4287 3.0551 18.3618 2.93626 18.2429C2.81742 18.1241 2.75045 17.963 2.75 17.795V7.4292H18.5625C18.7448 7.4292 18.9197 7.50163 19.0486 7.63056C19.1776 7.75949 19.25 7.93436 19.25 8.1167V10.8667",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_16854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.554199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSidebarFolder);
export default __webpack_public_path__ + "static/media/icon-sidebar-folder.b35ca9f73f870b5777de7008fab5af72.svg";
export { ForwardRef as ReactComponent };